<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!---------------------------------------- Table Content --------------------------------------->

  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td>
          <td-value copyToClipboard [value]="item?.id"></td-value>
        </td>

        <!-- title -->
        <td>
          <td-value
            copyToClipboard
            class="font-vazir-ui"
            [value]="item?.title"
          ></td-value>
        </td>

        <!-- depositPrice -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.depositPrice"
            type="number"
          ></td-value>
        </td>

        <!-- originalPrice -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.originalPrice"
            type="number"
          ></td-value>
        </td>

        <!-- remainingCredit -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.remainingCredit"
            type="number"
          ></td-value>
        </td>

        <!-- packageStatus -->
        <td>
          <span [packageStatus]="item?.packageStatus">
            {{ item?.packageStatus | enumToText : PackageStatusEnumValues }}
          </span>
        </td>

        <!-- purchaseDate -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.purchaseDate"
          ></td-value>
        </td>

        <!--  expirationDate -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            *ngIf="item.packageStatus != PackageStatus.Reserved"
            type="dateTimeWithSpace"
            [value]="item?.expirationDate"
          ></td-value>
          <span *ngIf="item.packageStatus == PackageStatus.Reserved">-</span>
        </td>

        <!--  activationDate -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.activationDate"
          ></td-value>
        </td>

        <td
          *ngIf="
            item?.packageStatus != PackageStatus.Canceled &&
            item?.packageStatus != PackageStatus.Expired
          "
          class="sticky-td"
        >
          <!-- delete -->
          <a
            (click)="onDelete(item.id, item.title)"
            class="btn btn-sm"
            [matTooltip]="'common.cancellation' | translate"
          >
            <i class="mdi mdi-trash-can-outline mdi-20px text-danger"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>
<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'PackageOrganizations'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
